import Vue from "vue";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";
//import { BootstrapVue } from 'bootstrap-vue';
// Install BootstrapVue
//Vue.use(BootstrapVue)
import VueMeta from "vue-meta";

// Snippets
import Filters from "./filters.js";
Vue.use(Filters);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Sentry.init({
  dsn:
    "https://9210a828ab174f808f34b7125cd71bf4@o468697.ingest.sentry.io/5496937",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

import { rtdbPlugin } from "vuefire";

import App from "./App.vue";
import router from "./router";
import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";
import store from "./store";

import { diff } from "deep-object-diff";
// Custom Filters

import InstantSearch from "vue-instantsearch";

Vue.use(InstantSearch);

import VueConfirmDialog from 'vue-confirm-dialog';
 
Vue.use(VueConfirmDialog);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);

import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyAh4_dIOHTdSboOmH3ABdKrqDg8uqmkpfc",
  authDomain: "dazzling-fire-5706.firebaseapp.com",
  databaseURL: "https://dazzling-fire-5706.firebaseio.com",
  projectId: "dazzling-fire-5706",
  storageBucket: "dazzling-fire-5706.appspot.com",
  messagingSenderId: "1016741158711",
  appId: "1:1016741158711:web:68b3dea8bf27f5e865c4b2",
  measurementId: "G-TX0KPB6XTD",
};

// Initialize Firebase
export const firebaseAuth = firebase.auth;

export const Firebase = firebase;

export const db = Firebase.initializeApp(firebaseConfig).database();

//.analytics();

//For Create User task so that users aren't automatically signed in which is the default
export const secondaryApp = firebase.initializeApp(firebaseConfig, "Secondary");

Vue.config.productionTip = false;

Vue.use(rtdbPlugin);

Vue.mixin({
  methods: {
    diffObj: function(originalObj, updatedObj) {
      return diff(originalObj, updatedObj);
    },
  },
});

Vue.mixin({
  beforeCreate() {
    const sync = this.$options.sync;
    if (sync) {
      if (!this.$options.computed) {
        this.$options.computed = {};
      }
      const attrs = Object.keys(this.$attrs);
      sync.forEach((key) => {
        if (!attrs.includes(key)) {
          Vue.util.warn(`Missing required sync-prop: "${key}"`, this);
        }
        this.$options.computed[key] = {
          get() {
            return this.$attrs[key];
          },
          set(val) {
            this.$emit("update:" + key, val);
          },
        };
      });
    }
  },
});

firebase.auth().onAuthStateChanged((user) => {
  //console.log("db", db);
  if (user) {
    db.ref("users/" + user.uid).once("value", (snapshot) => {
      console.log("snapshot", snapshot.val());
      //userObj.uid = user.uid;
      var userMergeObj = {
        userObj: snapshot.val(),
        auth: user,
      };
      //userObj.email = user.email;
      // do something with document
      //console.log('userObj', userObj);
      store.dispatch("fetchUser", userMergeObj);
    });
  }
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
